const mobileMenu = document.querySelector('#mobile-menu');
const toggleMenu = document.querySelector('#mobile-toggle');
const scrollUp = document.querySelector('#scroll-up');
const searchIcon = document.querySelector('#search-icon');

const cross = document.querySelectorAll('.cross');
const crossTitle = document.querySelectorAll('.cross-title');

mobileMenu.addEventListener('click', function (e) {
    this.classList.toggle("active");
    toggleMenu.classList.toggle("active");
});

cross.forEach((element) => {
    element.addEventListener('click', function (e) {
        this.classList.toggle('active')
        const subItems = this.closest("li").querySelector(".sub-items");
        if(subItems.style.maxHeight){
            subItems.style.maxHeight = null;
        } else {
            subItems.style.maxHeight = subItems.scrollHeight + 'px'
        }
    })
});

if(crossTitle) {
    crossTitle.forEach((element) => {
        element.addEventListener('click', function (e) {
            const subItems = this.closest("li").querySelector(".sub-items");
            if(subItems.style.maxHeight){
                subItems.style.maxHeight = null;
            } else {
                subItems.style.maxHeight = subItems.scrollHeight + 'px'
            }
        })
    });
}

if(searchIcon) {
    searchIcon.addEventListener('click', function (e) {
        const baseUrl = searchIcon.getAttribute("base_url");
        const searchInput = document.querySelector('input[name="search"]');
        if(baseUrl && searchInput.value) document.location.href = baseUrl + "?s=" + searchInput.value;
    })
}

scrollUp.addEventListener('click', function () {
    window.scroll({top: 0, left: 0, behavior: 'smooth'});
});

document.addEventListener('DOMContentLoaded', function() {
    const topText = document.querySelector('.top-text');
    const header = document.querySelector('.sticky-box');

    if (!topText || !header) return;

    // Get the offset position of the header
    const topTextHeight = topText.offsetHeight;
    let lastScrollTop = 0;

    window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Scrolling down and past the top-text
        if (scrollTop > topTextHeight && scrollTop > lastScrollTop) {
            header.classList.add('sticky');
        }
        // Scrolling up and back to original position
        else if (scrollTop <= topTextHeight) {
            header.classList.remove('sticky');
        }

        lastScrollTop = scrollTop;
    });
});


